import { FieldValues, useController, UseControllerProps } from "react-hook-form";
import { Input } from "@airhelp/react";
import { InputProps } from "@chakra-ui/react";
import { useTranslateZodError } from "../../utils/zod";

type ControlledInputProps<TFieldValues extends FieldValues> = InputProps &
  UseControllerProps<TFieldValues> & {
    label: string;
    placeholder: string;
    caption?: string;
    isDouble?: boolean;
    leftAddonText?: string;
  };

export function ControlledInput<T extends FieldValues>({
  label,
  placeholder,
  caption,
  name,
  rules,
  shouldUnregister,
  defaultValue,
  control,
  sanitizeInput,
  ...inputProps
}: ControlledInputProps<T> & { sanitizeInput?: (value: string) => string }) {
  const {
    field,
    fieldState: { invalid, error },
  } = useController({
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
  });
  const translateError = useTranslateZodError();
  return (
    <Input
      {...field}
      value={field.value || ""}
      onChange={(e) =>
        sanitizeInput
          ? field.onChange(sanitizeInput(e.target.value))
          : field.onChange(e.target.value)
      }
      errorMessage={translateError(error?.message || "")}
      isInvalid={invalid}
      label={label}
      placeholder={placeholder}
      caption={caption}
      {...inputProps}
    />
  );
}
